import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { PromotionsService } from '../../promotions.service';

@Component({
  selector: 'app-new-promotion-smart',
  template: '<app-new-promotion [codeGroups]="codeGroups" [serviceCountries]="serviceCountries"></app-new-promotion>',
  styles: [
  ]
})
export class NewPromotionSmartComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  // providers: any;
  serviceCountries: [];
  codeGroups: [];
  carrierDetails: [];
  productId: any;
  
  constructor(private promotionsService: PromotionsService, private activeRoute: ActivatedRoute) {
    super();
    this.getAllProductServiceData();
  }

  getAllProductServiceData() {
    //this.productId = this.activeRoute.snapshot.params.id;
    //let carrierDetails = this.promotionsService.getcarrierPromotionsId(this.productId);
    let codeGroups = this.promotionsService.getcodeGroups();
    let serviceCountries = this.promotionsService.getCarrierCountries();

    forkJoin([codeGroups, serviceCountries]).subscribe(
      res => {
        //this.carrierDetails = res[0]['data'];
        //console.log(this.carrierDetails);
        this.codeGroups = res[0].data;
        this.serviceCountries = res[1]['data'];
      }
    );
  }


  ngOnInit(): void {
    super.ngOnInit();

  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

}
